@import '../modal.utility.scss';

wb-modal-header {
  display: flex;
  align-items: center;
  height: $modal-header-height;
  border-bottom: 1px solid var(--wb-grey-85);
  padding: 11px;

  .wb-modal__close-button {
    margin-left: auto;
  }

  &.wb-modal-part--hidden {
    transform: translateY(-100%);
  }

  &.wb-modal-part--visible {
    transform: translateY(0%);
  }
}
